var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import { classNames } from '@shapeable/utils';
var cls = classNames('badge-divider');
export var BadgeDividerClassNames = cls;
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
export var BadgeDividerDefaultProps = {
  lineVariant: 'solid',
  showLine: true
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: 32px;\n    position: relative;\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    font-size: ", ";\n    color: ", ";\n  "], ["\n    height: 32px;\n    position: relative;\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    font-size: ", ";\n    color: ", ";\n  "])), theme.FONT_SIZE(13), theme.COLOR('strong'))
});
var LineStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: absolute;\n    width: 100%;\n    top: 15px;\n    margin: 0;\n    border: none;\n\n    ", "\n\n    ", "\n  "], ["\n    position: absolute;\n    width: 100%;\n    top: 15px;\n    margin: 0;\n    border: none;\n\n    ", "\n\n    ", "\n  "])), function (props) {
    return props.variant === 'solid' && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      border-bottom: 1px solid ", ";\n    "], ["\n      border-bottom: 1px solid ", ";\n    "])), theme.COLOR('line-mid'));
  }, function (props) {
    return props.variant === 'dotted' && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      height: 2px;\n      margin-top: -1px;\n      ", ";\n    "], ["\n      height: 2px;\n      margin-top: -1px;\n      ", ";\n    "])), theme.H_DOT_BG_END());
  })
});
var BadgeStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    z-index: 20;\n    margin: 0;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    position: relative;\n    border: 1px solid ", ";\n    border-radius: 18px;\n    background: ", ";\n    padding: 0 ", ";\n    line-height: 1.35em;\n    height: 30px;\n    font-size: 1em;\n    text-transform: capitalize;\n  "], ["\n    z-index: 20;\n    margin: 0;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    position: relative;\n    border: 1px solid ", ";\n    border-radius: 18px;\n    background: ", ";\n    padding: 0 ", ";\n    line-height: 1.35em;\n    height: 30px;\n    font-size: 1em;\n    text-transform: capitalize;\n  "])), theme.COLOR('line-mid'), theme.COLOR('canvas'), theme.UNIT(10))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Line: styled.hr.attrs(cls.attr('line'))(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), LineStyles),
  Badge: styled.h4.attrs(cls.attr('badge'))(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), BadgeStyles)
};
export var BadgeDivider = function (props) {
  var className = props.className,
    children = props.children,
    onClick = props.onClick,
    lineVariant = props.lineVariant,
    showLine = props.showLine;
  return React.createElement(My.Container, {
    onClick: onClick,
    className: cls.name(className)
  }, showLine && React.createElement(My.Line, {
    variant: lineVariant
  }), React.createElement(My.Badge, null, children));
};
BadgeDivider.defaultProps = BadgeDividerDefaultProps;
BadgeDivider.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;